import { render, staticRenderFns } from "./previousOrders.vue?vue&type=template&id=b47d3d04&"
import script from "./previousOrders.vue?vue&type=script&lang=js&"
export * from "./previousOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports